/**
 * See Jesus Groups: short-term groups that are part of the See Jesus
 * campaign (woodsidebible.org/see-jesus). MP marks them with the
 * "See Jesus Group" website tag; the API surfaces that as `seeJesus`.
 *
 * Brand tokens mirror the pledge widget (widgets/commitment-form):
 * black, cream, gold, Pirata One for display type. The logo and a
 * downsized foil (900px JPEG, ~1/10th of the pledge widget's PNG) live in
 * this package's public folder, served from widgets-host.
 */

/**
 * Where the See Jesus assets are served from. widgets-host in production;
 * a host page can point it elsewhere through the widget config (previews).
 * The shell also writes it into `--sj-foil-url` for the stylesheet.
 */
export const DEFAULT_ASSET_BASE = 'https://widgets.woodsidebible.org/group-finder';
let assetBase = DEFAULT_ASSET_BASE;
export function setSeeJesusAssetBase(base: string) {
  assetBase = base.replace(/\/$/, '');
  SEE_JESUS.logoUrl = `${assetBase}/see-jesus/logo.png`;
  SEE_JESUS.markUrl = `${assetBase}/see-jesus/mark.png`;
  SEE_JESUS.foilUrl = `${assetBase}/see-jesus/foil.jpg`;
}
export function seeJesusFoilUrl(base: string = assetBase): string {
  return `${base.replace(/\/$/, '')}/see-jesus/foil.jpg`;
}

export const SEE_JESUS = {
  black: '#000000',
  ink: '#1a1410',
  cream: '#f6efe9',
  gold: '#c79854',
  goldBright: '#e8c998',
  goldDark: '#8b6a2f',
  logoUrl: `${DEFAULT_ASSET_BASE}/see-jesus/logo.png`,
  /** The compact eye badge (the mark inside the brand's "See Jesus" pill): for icon-sized uses like the finder's toggle, where the off-centre sunburst collapses. Gold on transparent. */
  markUrl: `${DEFAULT_ASSET_BASE}/see-jesus/mark.png`,
  foilUrl: `${DEFAULT_ASSET_BASE}/see-jesus/foil.jpg`,
  campaignUrl: 'https://woodsidebible.org/see-jesus/',
  displayFont: "'Pirata One', ui-serif, Georgia, serif",
};

/**
 * What a visitor reads when they ask "what is a See Jesus Group?". Drawn
 * from the launch copy the groups team sent (2026-09-10) and the campaign
 * page; edit here and only here.
 */
export const SEE_JESUS_COPY = {
  title: 'What is a See Jesus Life Group?',
  lead: 'An eight-week Life Group that’s part of See Jesus: a place to grow spiritually and get plugged in with Christ-centered community.',
  body: [
    'Over the next two years, our goal is for everyone who walks through our doors to do one thing: see Jesus. We’re in a new season as a church, praying that every person is equipped to pray, tell, and give.',
    'See Jesus Life Groups run for eight weeks. You’ll process the weekend teaching together, practice what it looks like to help the people around you see Jesus, and take next steps in community. When the eight weeks are up, the group decides together what comes next.',
    'New here, or still figuring out what you believe? Yes, this is for you. You’re looking for Jesus, and He’s closer than you think.',
  ],
  campaignLink: 'About the See Jesus campaign',
};

/** Title treatment on See Jesus headers: blackletter, title case, cut from the foil. */
export const SJ_TITLE =
  'sj-foil-text sj-display text-3xl leading-none font-normal tracking-normal normal-case sm:text-4xl';
